import { useEffect, useRef, useState } from 'react'
import Clipboard from 'clipboard'
import Alert from '../Alert/Alert'

import { createGUID } from '../../utils/strings'

export default function ClipboardButton (props = {
    alertDuration: null,
    id: null,
    className: null,
    icon: null,
    iconSize: 18,
    iconOrderLast: false,
    successText: null,
    failText: null,
    style: null
}) {
    const {
        alertDuration,
        children,
        icon,
        iconSize,
        iconOrderLast,
        successText,
        failText,
        ...renderProps
    } = props

    const clipboardBtn = useRef()

    const [state, setState] = useState(null)

    useEffect(() => {
        if (!clipboardBtn.current)
            return

        let alertTimeout

        const clipboard = new Clipboard(clipboardBtn.current)

        const onCopy = (state, e) => {
            if (state === 'error')
                console.warn(e)

            if (alertTimeout)
                clearTimeout(alertTimeout)

            setState(state)

            alertTimeout = setTimeout(() => clipboardBtn.current
                && setState(null), alertDuration || 2400)
        }

        clipboard
            .on('success', e => onCopy('success', e))

        clipboard
            .on('error', e => onCopy('error', e))

        return () => clearTimeout(alertTimeout)
            && clipboardBtn
            && clipboardBtn.current
            && clipboard.destroy()
    }, [clipboardBtn])

    if (!children
            || !Clipboard.isSupported())
        return null

    const alertId = state
        && `${props.id || `clipboard-button-${createGUID()}-`}-msg`

    const renderIcon = () => (
        <svg
            className={`${icon} flex-none`}
            width={`${iconSize || 18}`}
            height={`${iconSize || 18}`}
        >
            <use xlinkHref={`#${icon}`} />
        </svg>
    )

    return (
        <>
            <button
                ref={clipboardBtn}
                aria-describedby={alertId}
                {...renderProps}
            >
                {icon
                    && !iconOrderLast
                    && renderIcon()}
                {children}
                {icon
                    && iconOrderLast
                    && renderIcon()}
            </button>
            {alertId
                && (
                    <div
                        style={{ paddingTop: '15px' }}
                    >
                        <Alert
                            id={alertId}
                            className="display-inline-flex"
                            role={state === 'success'
                                ? 'status'
                                : 'alert'}
                            type={state}
                            dismissible={false}
                            fluidCondensed
                            icon
                        >
                            <p>
                                {state === 'success'
                                    ? successText || 'Copied'
                                    : failText || 'Copy failed'}
                            </p>
                        </Alert>
                    </div>)}
        </>
    )
}
